<template>
  <span>
    <ExternalMessageModal />
    <InternalMessageModal />
    <InvoiceMessageModal />
    <NoteMessageModal />
    <TaskModal />
    <RequestTextModal />
  </span>
</template>

<script>
import ExternalMessageModal from './ExternalMessageModal.vue'
import InternalMessageModal from './InternalMessageModal.vue'
import InvoiceMessageModal from './invoices/InvoiceMessageModal.vue'
import NoteMessageModal from './NoteMessageModal'
import RequestTextModal from './RequestTextModal'
import TaskModal from './TaskModal'

export default {
  name: 'MessageBoxes',
  components: {
    ExternalMessageModal,
    InvoiceMessageModal,
    InternalMessageModal,
    NoteMessageModal,
    RequestTextModal,
    TaskModal
  }
}
</script>

<style lang="scss">
.message-box {
  .message-box-content {
    flex: 0 1 100%;
    display: flex;
    flex-direction: column;
  }
  .message-contents-field,
  .editor-field {
    display: flex;
    flex-direction: column;
    flex: 0 1 100%;
  }

  .nr-editor {
    flex: 1 1 auto;
  }

  .nr-datepicker-calendar {
    .nr-datepicker-calendar-header__button {
      border: none;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
    .nr-datepicker-calendar-dates .button {
      border-width: inherit;
      padding: inherit;
    }
    .table td,
    .table th {
      padding: inherit;
      border: inherit;
    }
  }
}
</style>
